
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"21","viewBox":"0 0 12 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 10.5001C0 10.9792 0.196598 11.4297 0.559546 11.773L8.74858 19.5175C9.4896 20.2183 10.6994 20.2183 11.4405 19.5175C12.1815 18.8167 12.1815 17.6725 11.4405 16.9717L4.59735 10.5001L11.4405 4.02842C11.8034 3.69232 12 3.23466 12 2.75554C12 2.27642 11.8034 1.82591 11.4405 1.48266C10.6994 0.781862 9.4896 0.781862 8.74858 1.48266L0.559546 9.2272C0.196598 9.57045 0 10.021 0 10.5001Z"}})])
          )
        }
      }
    